mutation NotePayCycleCreate($input: NotePayCycleCreateInput!) {
  notePayCycleCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
